module.exports = __webpack_public_path__ + "img/wyotech-logo.8f7c3487.png";